import Vue from 'vue'
import VueRouter from 'vue-router'
const PrivacyAgreement=()=>import('../views/privacyAgreement')
const UsersAgreement=()=>import('../views/usersAgreement')
const Home=()=>import('../views/Home')
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
    {
      path: '/usersAgreement',
      name: 'UsersAgreement',
      component: UsersAgreement
    },
    {
      path: '/privacyAgreement',
      name: 'PrivacyAgreement',
      component: PrivacyAgreement
    },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
